import styled from 'styled-components';
import MySafetySvg from '../../assets/hotels/mysafety.svg';

const MySafetyIcon = styled(MySafetySvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '17.9rem'};
  height: ${props => props.height || '2.3rem'};
  margin: ${props => props.margin};
`;

export default MySafetyIcon;
